import { AnimatePresence, motion } from 'framer-motion';
import { AlertTriangle, CheckCircle2, Info, X } from 'lucide-react';
import { useUiStore, type ToastItem } from '@/store/uiStore';
import { cn } from '@/utils/cn';

const ICONS: Record<ToastItem['variant'], typeof Info> = {
  success: CheckCircle2,
  error: AlertTriangle,
  info: Info,
};

const ICON_COLORS: Record<ToastItem['variant'], string> = {
  success: 'text-emerald-400',
  error: 'text-red-400',
  info: 'text-sky-400',
};

export function Toasts() {
  const toasts = useUiStore((s) => s.toasts);
  const dismissToast = useUiStore((s) => s.dismissToast);

  return (
    <div
      className="pointer-events-none fixed bottom-4 right-4 z-[70] flex w-full max-w-sm flex-col gap-2"
      aria-live="polite"
    >
      <AnimatePresence>
        {toasts.map((item) => {
          const Icon = ICONS[item.variant];
          return (
            <motion.div
              key={item.id}
              layout
              initial={{ opacity: 0, y: 16, scale: 0.97 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, x: 24 }}
              className="pointer-events-auto glass-strong flex items-start gap-3 p-4 shadow-card"
            >
              <Icon className={cn('mt-0.5 h-5 w-5 shrink-0', ICON_COLORS[item.variant])} aria-hidden />
              <div className="min-w-0 flex-1">
                <p className="text-sm font-semibold text-zinc-100">{item.title}</p>
                {item.description && (
                  <p className="mt-0.5 break-words text-xs text-zinc-400">{item.description}</p>
                )}
              </div>
              <button
                onClick={() => dismissToast(item.id)}
                className="text-zinc-500 transition-colors hover:text-zinc-300"
                aria-label="Dismiss notification"
              >
                <X className="h-4 w-4" />
              </button>
            </motion.div>
          );
        })}
      </AnimatePresence>
    </div>
  );
}
